module.exports = __webpack_public_path__ + "img/ch8.0a3c3ec7.png";